module.exports = __webpack_public_path__ + "static/media/create-channel-icon.15f4a911.svg";